import React from 'react'
import PropTypes from 'prop-types'
import MaskedInput from 'react-text-mask'
import { Input, Label } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper'
import createAutoCorrectionTimePipe from '../../../utils/createAutoCorrectionTimePipe'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

const TimeField = formFieldWrapper((fieldProps, showError) => {
  const {
    elmId,
    label, // eslint-disable-line
    placeholder,
    inputLabel,
    onChange,
    onBlur,
    onFocus,
    value,
    compact,
    className,
    keepCharPositions = true,
    includeSeconds = false,
    ...rest
  } = fieldProps

  const newClassName = classnames({
    compact,
    labeled: inputLabel,
    [className]: true,
  })

  const timeFormat = includeSeconds ? 'HH:MM:SS A' : 'HH:MM A'

  // Generates a mask based on passed in prop timeFormat(default is HH:MM A).
  // If you pas "HH:MM:SS A" it will generate a mask that will account for seconds
  const mask = timeFormat.split('').reduce((mask, char) => {
    switch (char) {
      case 'H':
      case 'M':
      case 'S':
        return [...mask, /\d/]
      case ':':
        return [...mask, ':']
      case 'A':
        return [...mask, ' ', /[aApP]/, 'M']
      default:
        return mask
    }
  }, [])

  return (
    <Input
      error={showError}
      data-elm-id={`${elmId}_input`}
      className={newClassName}
      {...rest}
    >
      {!!inputLabel && <Label>{inputLabel}</Label>}
      <MaskedInput
        className={cx('masked-input')}
        mask={mask}
        keepCharPositions={keepCharPositions}
        placeholder={
          placeholder || (includeSeconds ? 'Ex. 03:15:45 PM' : 'Ex. 03:15 PM')
        }
        pipe={createAutoCorrectionTimePipe(timeFormat)}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value}
      />
    </Input>
  )
})

TimeField.propTypes = {
  ...commonPropTypes,
  includeSeconds: PropTypes.bool,
  keepCharPositions: PropTypes.bool,
}

export default TimeField
